import { normalizeHeaderImages } from './localImage.js';

export const IMAGE_HEADER_TYPE = 'image-header';

export function getImageHeaderDefaults(extra = {}) {
	return normalizeImageHeaderData({
		items: [],
		imageStyle: 'full',
		displayMode: 'carousel',
		...extra,
	});
}

export function normalizeImageHeaderData(data = {}) {
	const normalized = normalizeHeaderImages(data);
	// 正文图片固定撑满，不开放留白/撑满设置
	normalized.imageStyle = 'full';
	return normalized;
}

export function isImageHeaderBlock(type) {
	return type === IMAGE_HEADER_TYPE;
}
